import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const CatalogItemTitleStyled = styled(Text)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  line-height: ${(props) => props.theme.typography.pxToRem(24)};
`
